import { sendGTMEvent } from '~/features/shared/gtmEvent/sendGTMEvent'
import {
  BalloonLabel,
  CoordinateImageSwipeLabel,
  ImageSearchCloseType,
  ItemImageLabel,
  ItemSiteType,
} from '~/features/shared/gtmEvent/types/coordinateDetail'
import { GtmEvent } from '~/features/shared/gtmEvent/types/gtmEvent'

export const sendGtmEvCoordinateBalloon = (label: BalloonLabel) => {
  sendGTMEvent({
    event: 'snapimage_itemtag',
    eventCategory: 'click',
    eventAction: 'snapimage',
    eventLabel: label,
  })
}

export const sendGtmEvCoordinateImageSwipe = (
  label: CoordinateImageSwipeLabel
) => {
  sendGTMEvent({
    event: 'snap_swipeimages',
    eventCategory: 'multiple',
    eventAction: 'coordinatedetail',
    eventLabel: label,
  })
}

export const sendGtmEvImageSearchButton = () => {
  sendGTMEvent({
    event: '201911_similarimages_searchlens',
    eventCategory: 'click',
    eventAction: 'similarimages_searchlens',
    eventLabel: '',
  })
}

export const sendGtmEvItemImage = (
  label: ItemImageLabel,
  siteType: ItemSiteType
) => {
  sendGTMEvent({
    event: 'snapdetail_itemimage',
    eventCategory: 'click',
    eventAction: 'snapdetail_itemimage',
    eventLabel: label,
    link_site_type: siteType,
  })
}

export const sendGtmEvItemImageButton = (eventData: GtmEvent) => {
  sendGTMEvent(eventData)
}

export const sendGtmEvItemImageSearchNotFound = () => {
  sendGTMEvent({
    event: '201911_similarimages_analysisresult_item',
    eventCategory: 'imp',
    eventAction: 'similarimages_analysisresult_item',
    eventLabel: 'notfound',
  })
}

export const sendGtmEvItemImageSearchClose = (
  eventElm: ImageSearchCloseType,
  label: string
) => {
  sendGTMEvent({
    event: '201911_similarimages_analysisresult_item',
    eventCategory: 'imp',
    eventAction: 'similarimages_analysisresult_item',
    eventLabel: label,
  })
}

export const sendGtmEvPopularityCoordinateAppButton = () => {
  sendGTMEvent({
    event: 'mdrAppOpen',
    eventCategory: 'link',
    linktype: 'open',
    pageGroup: 'content_f_snapdetail',
  })
}

export const sendGtmEvAppRedirectHalfModalButton = () => {
  sendGTMEvent({
    event: 'content_dynamiclink',
    pageGroup: 'snapdetail',
    click_content_type: 'modal',
  })
}

export const sendGtmEvShowHalfModal = () => {
  sendGTMEvent({
    event: 'imp_content_dynamiclink',
    pageGroup: 'snapdetail',
    click_content_type: 'modal',
  })
}
